// Tabs for sections/featured-collections.liquid ("Show products in tabs" on).
// Follows the WAI-ARIA tabs pattern: roving tabindex, arrow/Home/End keys and
// automatic activation. Every DOM query is null-checked so the section keeps
// working (or bails quietly) when parts of its markup are absent.
class FeaturedCollectionsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    // Theme editor: selecting a collection block in the sidebar shows its tab.
    this.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail && event.detail.blockId;
      const index = this.tabs.findIndex((tab) => tab.dataset.blockId === blockId);
      if (index > -1) this.select(index);
    });
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
        next = index === last ? 0 : index + 1;
        break;
      case 'ArrowLeft':
        next = index === 0 ? last : index - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }

  select(index) {
    const activeTab = this.tabs[index];
    if (!activeTab) return;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    const panelId = activeTab.getAttribute('aria-controls');
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });

    // Keep the active tab in view when the tab row scrolls sideways.
    if (activeTab.scrollIntoView) {
      activeTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    // A mobile Swiper created while its panel was visible measured that layout;
    // re-measure now it's showing again. One not yet created builds itself on
    // first view (mobile-swiper.js waits until it's near the viewport).
    const activePanel = this.panels.find((panel) => panel.id === panelId);
    const carousel = activePanel && activePanel.querySelector('[data-mobile-swiper]');
    if (carousel && carousel.swiper) carousel.swiper.update();
  }
}

if (!customElements.get('featured-collections-tabs')) {
  customElements.define('featured-collections-tabs', FeaturedCollectionsTabs);
}
